import { useMediaQuery } from '@mui/material';
import { Suspense, useEffect, useState, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../../Utils/Constants/routes';
import { useAuthContext } from '../../Context/authContext';
import { useTheme } from '@emotion/react';
import { TABLET_BREAKPOINT } from '../../Utils/Constants/constant';
import { useAppContext } from '../../Context/appContext';
import { getApplicationsByApplicantId, getAxiosInstance, getAllQueryByApplicantId } from '../../Utils/apiServices';
import { PrivateRouter, PublicRouter } from '../../Utils/Helpers/applicationHelper';
import home from '../../Assets/Icons/home.png';
import allPrograms from '../../Assets/Icons/allPrograms.png';
import myApplications from '../../Assets/Icons/myApplications.png';
import payments from '../../Assets/Icons/payments.png';
import documents from '../../Assets/Icons/documents.png';
import KenLoader from '../../Components/KenLoader';
import homeII from '../../Assets/Icons/home II.png';
import allApplicationII from '../../Assets/Icons/education.png';
import profileInfo from '../../Assets/Icons/profileInfo.png';
import myapplicationII from '../../Assets/Icons/education.png';
import paymentsII from '../../Assets/Icons/billing.png';
import documentsII from '../../Assets/Icons/documents II.png';
import serviceAndSupport from '../../Assets/Icons/serviceAndSupport.png';
import Raiseaquery from '../../Assets/Icons/Raiseaquery.png';
import RaiseaqueryMobile from '../../Assets/Icons/queryMobile.png';
import { VscBellDot } from 'react-icons/vsc';
import NotifyIcon from '../../Assets/Icons/NotifyIcon.svg';
import { useLocation } from 'react-router-dom';

const AppLayout = lazy(() => import('../../Components/AppLayout'));
const HomePage = lazy(() => import('../HomePage'));
const DocumentPage = lazy(() => import('../DocumentPage'));
const Login = lazy(() => import('../../Components/RegistrationForm'));
const SignUp = lazy(() => import('../Auth/SignUp'));
const Courses = lazy(() => import('../Courses'));
const MyApplications = lazy(() => import('../MyApplications'));
const ApplicationFormNew = lazy(() => import('../ApplicationForm'));
const PaymentHistory = lazy(() => import('../PaymentHistory'));
const LandingPageCommon = lazy(() => import('../../Containers/LandingPageCommonPage'));
const DEMLandingPage = lazy(() => import('../DEMLandingPage/index.js'));
const GSCMLandingPage = lazy(() => import('../GSCMLandingPage/index.js'));
const Faq = lazy(() => import('../FAQ'));
const CourseEligibility = lazy(() => import('../CourseEligibility'));
const ThankyouScreen = lazy(() => import('../Auth/ThankyouForRegistering'));
const RegistrationOTPVerification = lazy(() => import('../Auth/RegistrationOTPVerification'));
const ConfirmingEmail = lazy(() => import('../Auth/ConfirmingEmail'));
const ResetPassword = lazy(() => import('../Auth/ResetPassword'));
const ResetPasswordMain = lazy(() => import('../Auth/ResetPasswordMain'));
const QueryHistory = lazy(() => import('../../Containers/RaiseaQuery/Components/QueryHistory'));
const QueryOverview = lazy(() => import('../../Containers/RaiseaQuery/Components/ReviewRequest'));
const EMBALandingPage = lazy(() => import('../EMBALandingPage/index.js'));
const SPMLandingPage = lazy(() => import('../SPMLandingPage/index.js'));
const StudentInterviewModule = lazy(() => import('../studentInterviewModule/index.js'));
const InterviewBookslotTab = lazy(() => import('../studentInterviewModule/Components/InterviewBookslotTab/index.jsx'));
const PhDLandingPage = lazy(() => import('../PhDLandingPage/index.js'));
const EphdLandingPage = lazy(()=> import('../EphdLandingPage/index.js') );
const ExEdLandingPage = lazy(() => import('../ExEdLandingPage/index.js'));
const ExEdDashboard = lazy(() => import('../ExEdDashboard'));
const ExEdGroupDashboard = lazy(() => import('../ExEdDashboard/ExEdGroupDashboard'));
const ExEdGroupDashboardAnalysis = lazy(() => import('../ExEdDashboard/ExEdGroupDashboardAnalysis'));
const DynamicDashboard = lazy(() => import('../ExEdDashboard/DynamicDashboard'));
const ExEdCourses = lazy(() => import('../ExEdCourses'));
const PaymentSummary = lazy(() => import('../PaymentSummary'));
const ProfilePage = lazy(() => import('../ProfilePage'));
const OrganizationPage = lazy(() => import('../OrganizationPage'));
const NominationPage = lazy(() => import('../NominationPage'));
const NominationOverviewPage = lazy(() => import('../NominationOverviewPage'));
const NomineeListPage = lazy(() => import('../NomineeListPage'));
const GroupApplicationPage = lazy(() => import('../GroupApplicationPage'));
const BillingPage = lazy(() => import('../BillingPage'));
const Service = lazy(() => import('../Service'));
const FAQDetail = lazy(() => import('../Service/components/FAQDetail'));
const TicketPreview = lazy(() => import('../Service/components/Ticket/TicketPreview'));
const TicketTabs = lazy(() => import('../Service/components/AllTickets'));

export default function MainLayout(props) {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const {
    state: { isLoading = false },
  } = useAppContext();
  const {
    state: { user, enquiryType },
  } = useAuthContext();
  const [publishedCount, setPublishedCount] = useState(0);
  const location = useLocation();
  const fetchQueries = async () => {
    try {
      if (!user?.applicantId) return;

      const response = await getAllQueryByApplicantId(user.applicantId);
      console.log('Query Response:', response);

      let count = 0;
      response.forEach((item) => {
        const comments = item.comments;
        if (Array.isArray(comments)) {
          const published = comments.filter((comment) => comment?.createdByName !== 'Application Portal Integration User' && comment?.isPublished === true);
          count += published.length;
        }
      });

      setPublishedCount(count);
      console.log('Total published comments:', count);
    } catch (error) {
      console.error('Error fetching queries:', error);
    }
  };

  useEffect(() => {
    fetchQueries();
  }, [user?.applicantId]);

  useEffect(() => {
    if (location.pathname === routes.queryView) {
      fetchQueries();
    }
  }, [location.pathname]);

  // Individual menu configuration based on first image
  const individualMenu = [
    {
      icon: home,
      mobileIcon: home,
      label: 'Home',
      link: routes.home,
      callback: '',
    },
    {
      icon: allApplicationII,
      mobileIcon: allApplicationII,
      label: 'Programs',
      link: routes.exedCourses,
      callback: '',
    },
    {
      icon: profileInfo,
      mobileIcon: profileInfo,
      label: 'Profile',
      link: routes.profile,
      callback: '',
    },
    // Hide billing for nominees
    ...(user?.isNominee ? [] : [{
      icon: paymentsII,
      mobileIcon: paymentsII,
      label: 'Billing',
      link: routes.billing,
      callback: '',
    }]),
    {
      icon: serviceAndSupport,
      mobileIcon: serviceAndSupport,
      label: 'Service & Support',
      link: routes.service,
      callback: '',
    },
  ];

  // Corporate menu configuration based on second image
  const corporateMenu = [
    {
      icon: home,
      mobileIcon: home,
      label: 'Home',
      link: routes.home,
      callback: '',
    },
    {
      icon: profileInfo,
      mobileIcon: profileInfo,
      label: 'Organization Information',
      link: routes.organizationInfo,
      callback: '',
    },
    {
      icon: allApplicationII,
      mobileIcon: allApplicationII,
      label: 'Programs',
      link: routes.exedCourses,
      callback: '',
    },
    {
      icon: documents,
      mobileIcon: documents,
      label: 'Nominations',
      link: routes.nominationOverview,
      callback: '',
    },
    
    {
      icon: paymentsII,
      mobileIcon: paymentsII,
      label: 'Billing',
      link: routes.billing,
      callback: '',
    },
    {
      icon: serviceAndSupport,
      mobileIcon: serviceAndSupport,
      label: 'Service & Support',
      link: routes.service,
      callback: '',
    },
  ];

  // Default to individual menu if enquiryType is not available
  const getMenuByEnquiryType = () => {
    if (enquiryType === 'Corporate') {
      return corporateMenu;
    }
    return individualMenu; // Default for "Individual" or undefined enquiryType
  };

  const menu = getMenuByEnquiryType();

  const [sideNavMenu, setSideNavMenu] = useState(menu);

  getAxiosInstance();

  // useEffect(() => {
  //   setSideNavMenu(menu);
  // }, [menu]);
  useEffect(() => {
    setSideNavMenu(getMenuByEnquiryType());
  }, [publishedCount, enquiryType, user?.isNominee]);

  useEffect(() => {
    if (user?.applicantId) {
      getApplicationsByApplicantId(user?.applicantId).then((res) => {
        const tempData = [...sideNavMenu];
        if ((res?.data || 0)?.length > 0) {
          if (sideNavMenu?.filter((s) => s.label === 'Payments')?.length === 0) {
            tempData.push({
              icon: payments,
              mobileIcon: payments,
              label: 'Payments',
              link: routes.feePaymentHistory,
              callback: '',
            });
          }

          if (sideNavMenu?.filter((s) => s.label === 'Documents')?.length === 0) {
            tempData.push({
              icon: documents,
              mobileIcon: documents,
              label: 'Documents',
              link: routes.document,
              callback: '',
            });
          }

          // Interview → check for Application Status
          const hasInterview = res?.data?.some((item) => item?.hed__Application_Status__c === 'Interview');

          if (hasInterview && sideNavMenu?.filter((s) => s.label === 'Interview')?.length === 0) {
            tempData.push({
              icon: home,
              mobileIcon: home,
              label: 'Interview',
              link: routes.studentInterviewTab,
              callback: '',
            });
          }

          setSideNavMenu([...tempData]);
        }
      });
    }
  }, [isMobileScreen, user?.applicantId, location.pathname, location.key]);

  return (
    <>
      {/* {isLoading && <KenLoader />} */}
      <Suspense fallback={<KenLoader />}>
        <Routes>
          <Route caseSensitive path={`*`} element={<Navigate to={routes.newlandingpage} />} />
          {/* Public Router */}
          <Route caseSensitive path={routes.verify} element={<ConfirmingEmail />} />
          <Route
            exact
            caseSensitive
            path={`/`}
            element={
              <PublicRouter>
                <ExEdLandingPage/>
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.landingPage}
            element={
              <PublicRouter>
                <LandingPageCommon />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.demlandingpage}
            element={
              <PublicRouter>
                <DEMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.gscmlandingpage}
            element={
              <PublicRouter>
                <GSCMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.embalandingpage}
            element={
              <PublicRouter>
                <EMBALandingPage />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.spmlandingpage}
            element={
              <PublicRouter>
                <SPMLandingPage />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.phdlandingpage}
            element={
              <PublicRouter>
                <PhDLandingPage/>
              </PublicRouter>
            }
          />
           <Route
            caseSensitive
            path={routes.ephdlandingpage}
            element={
              <PublicRouter>
                <EphdLandingPage/>
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.login}
            element={
              <PublicRouter>
                <ExEdLandingPage />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.signup}
            element={
              <PublicRouter>
                <SignUp />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.success}
            element={
              <PublicRouter>
                <ThankyouScreen />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.verifyRegistration}
            element={
              <PublicRouter>
                <RegistrationOTPVerification />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.resetpassword}
            element={
              <PublicRouter>
                <ResetPassword />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.resendVerification}
            element={
              <PublicRouter>
                <ResetPassword />
              </PublicRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.resetPasswordMain}
            element={
              <AppLayout sideNavMenu={sideNavMenu}>
                <ResetPasswordMain />
              </AppLayout>
            }
          />

          {/* Private Router */}
          <Route
            caseSensitive
            path={routes.applicationForm}
            element={
              <PrivateRouter>
                <ApplicationFormNew />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.paymentSummary}
            element={
              <PrivateRouter>
                  <PaymentSummary />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.groupApplication}
            element={
              <PrivateRouter>
                  <GroupApplicationPage />
              </PrivateRouter>
            }
          />
          <Route
            caseSensitive
            path={routes.ticketPreview}
            element={
              <PrivateRouter>
                <AppLayout sideNavMenu={sideNavMenu}>
                  <TicketPreview />
                </AppLayout>
              </PrivateRouter>
            }
          />

          {/* Layout Routes */}
          <Route caseSensitive path="app" element={<AppLayout sideNavMenu={sideNavMenu} />}>
            <Route
              caseSensitive
              path={'home'}
              index
              element={
                <PrivateRouter>
                  <DynamicDashboard />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'exed-dashboard'}
              element={
                <PrivateRouter>
                  <ExEdDashboard />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'exed-group-dashboard'}
              element={
                <PrivateRouter>
                  <ExEdGroupDashboard />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'exed-group-dashboard-analysis'}
              element={
                <PrivateRouter>
                  <ExEdGroupDashboardAnalysis />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'exed-courses'}
              element={
                <PrivateRouter>
                  <ExEdCourses />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'document'}
              element={
                <PrivateRouter>
                  <DocumentPage />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={`paymentHistory`}
              element={
                <PrivateRouter>
                  <PaymentHistory />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={`billing`}
              element={
                <PrivateRouter>
                  <BillingPage />
                </PrivateRouter>
              }
            />

            <Route
              caseSensitive
              path={`faq`}
              element={
                <PrivateRouter>
                  <Faq />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'profile'}
              element={
                <PrivateRouter>
                  <ProfilePage />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'organization-info'}
              element={
                <PrivateRouter>
                  <OrganizationPage />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'courses'}
              element={
                <PrivateRouter>
                  <Courses />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'my-applications'}
              element={
                <PrivateRouter>
                  <MyApplications />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'eligibility'}
              element={
                <PrivateRouter>
                  <CourseEligibility />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'queryHistory'}
              element={
                <PrivateRouter>
                  <QueryHistory />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'queryView'}
              element={
                <PrivateRouter>
                  <QueryOverview />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'service'}
              element={
                <PrivateRouter>
                  <Service />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'service/faq/:categoryId'}
              element={
                <PrivateRouter>
                  <FAQDetail />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'studentInterviewTab'}
              element={
                <PrivateRouter>
                  <StudentInterviewModule />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'slotInterviewBooking'}
              element={
                <PrivateRouter>
                  <InterviewBookslotTab />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'nominations'}
              element={
                <PrivateRouter>
                  <NominationPage />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'nominations/overview'}
              element={
                <PrivateRouter>
                  <NominationOverviewPage />
                </PrivateRouter>
              }
            />
            <Route
              caseSensitive
              path={'nominations/program/:programId'}
              element={
                <PrivateRouter>
                  <NomineeListPage />
                </PrivateRouter>
              }
            />
          </Route>
          <Route
    caseSensitive
    path={routes.ticketTabs} // '/app/ticket-tabs'
    element={
      <PrivateRouter>
        <AppLayout sideNavMenu={sideNavMenu}>
          <TicketTabs />
        </AppLayout>
      </PrivateRouter>
    }
  />
        </Routes>
      </Suspense>
    </>
  );
}
